import { createSelector } from '@reduxjs/toolkit';
import { selectSupportedExchanges, selectTargetAccount } from 'src/store/trading/apiKeys/selectors';
import type { TradingState } from 'src/store/shared/tradingBots/types';
import {
  getCurrentExchange,
  getLastMessageId,
  getTradingGroupOptions,
  getTradingMessages,
} from 'src/store/utils/bots';

export interface Store {
  esTrading: {
    bots: TradingState;
  };
}

const selectorTradingGroupList = (state: Store) => state.esTrading.bots.groupList;
const selectorTradingSessionCreateStatus = (state: Store) =>
  state.esTrading.bots.sessionCreateStatus;
export const selectorTradingSessionDetails = (state: Store) => state.esTrading.bots.sessionDetails;
export const selectorTradingGroupListIsPending = (state: Store) =>
  state.esTrading.bots.groupListStatus === 'pending';
export const selectorTradingMessageStatus = (state: Store) => state.esTrading.bots.messageStatus;

export const selectorTradingGroupOptions = createSelector(
  selectorTradingGroupList,
  getTradingGroupOptions,
);

export const selectorIsSessionActive = createSelector(
  selectorTradingSessionCreateStatus,
  selectorTradingSessionDetails,
  (status, sessionDetails) => status === 'success' && sessionDetails !== null,
);

export const selectorTradingMessageLog = (state: Store) => state.esTrading.bots.messageLog;

export const selectorTradingMessages = createSelector(
  selectorTradingMessageLog,
  selectorTradingSessionDetails,
  getTradingMessages,
);

export const selectorTradingLastMessageId = createSelector(
  (state: Store) => state.esTrading.bots.messageLog,
  getLastMessageId,
);

export const selectDefaultExchange = createSelector(selectSupportedExchanges, (exchanges) => {
  if (!exchanges || exchanges.length === 0) {
    return null;
  }
  return exchanges[0] ?? null;
});

export const selectCurrentExchange = createSelector(
  selectSupportedExchanges,
  selectTargetAccount,
  selectDefaultExchange,
  getCurrentExchange,
);

export const selectorErrorBots = (state: Store) => state.esTrading.bots.error;
